import axios from "axios";
import { reqInstance, resolveUrl } from "./Common";

export const createAutoGeneratedUserReq = async (nickname) => {
  try {
    const resp = await reqInstance.post("user/create/auto-generated", { nickname });
    return resp.data;
  } catch (err) {
    throw err;
  }
};

export const loginReq = async (id, pw) => {
  try {
    const resp = await reqInstance.post("user/login", { id, encryptedPassword: pw });
    return resp.data;
  } catch (err) {
    throw err;
  }
};

export const signupReq = async (id, pw, nickname) => {
  try {
    const resp = await reqInstance.post("user/signup", { id, encryptedPassword: pw, nickname });
    return resp.data;
  } catch (err) {
    throw err;
  }
};

export const tokenTestReq = async () => {
  try {
    const resp = await reqInstance.post("user/tokenTest");
    return resp.data;
  } catch (err) {
    throw err;
  }
};

export const signOutReq = async () => {
  try {
    const resp = await reqInstance.post("user/signout");
    return resp.data;
  } catch (err) {
    throw err;
  }
};
